<template>
  <div>
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 25" :key="n" cols="12" sm="6" lg="3">
        <v-sheet class="mt-2">
          <v-skeleton-loader
            class="mx-auto"
            type="list-item"
          ></v-skeleton-loader>
        </v-sheet>
      </v-col>
    </v-row>
    <template v-else>
      <form-data
        :references.sync="formReferences"
        :model="modelObj"
        ref="offerReference"
      >
        <template slot="related_records">
          <div v-if="this.module !== 'sales'">
            <a v-if="relatedRecords && relatedRecords.length > 0">{{ module === 'offer' ? $t('message.layout.order') : $t('message.layout.offer') }}:</a>
            <a
              v-for="(record, index) in relatedRecords"
              :key="index"
              :href="`/orders/edit/${record.Id}/view`"
            >
              {{ record.Number
              }}{{ relatedRecords.length - 1 === index ? '' : ',' }}
            </a>
          </div>
        </template>
        <template slot="share_report" v-if="modelObj.type !== 'sales'">
          <template v-if="modelObj.type === 'order' || modelObj.type === 'rest_order'">
            <v-menu offset-y :disabled="email_menu">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="info" class="ml-3" v-on="on" @click="checkChangeBeforeAction(false)" :loading="false" v-if="modelObj.id" dark v-bind="attrs">
                  {{ $t('message.user.email') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in reportOptions" @click="shareOrder(item.value)" :key="index">
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-else>
            <v-menu offset-y :disabled="email_menu">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="info" class="ml-3" v-on="on" @click="checkChangeBeforeAction(false)" :loading="false" v-if="modelObj.id" dark v-bind="attrs">
                  {{ $t('message.user.email') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in offerOptions" @click="shareOrder(item.value)" :key="index">
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </template>
        <template slot="download_report" v-if="modelObj.type !== 'sales'">
          <template v-if="modelObj.type === 'order' || modelObj.type === 'rest_order'">
            <v-menu offset-y :disabled="email_menu">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="info" class="ml-3" @click="checkChangeBeforeAction(true)" :loading="downloadLoading" v-if="modelObj.id" dark v-bind="attrs"  v-on="on">
                  {{ $t('message.order.download') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item  v-for="(item, index) in reportOptions" @click="downloadOrder(item.value)" :key="index">
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-else>
            <v-menu offset-y :disabled="email_menu">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="info" class="ml-3" @click="checkChangeBeforeAction(true)" :loading="downloadLoading" v-if="modelObj.id" dark v-bind="attrs"  v-on="on">
                  {{ $t('message.order.download') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item  v-for="(item, index) in offerOptions" @click="downloadOrder(item.value)" :key="index">
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </template>
        <template slot="extraDetails">
          <v-layout wrap class="pa-0 pt-3 pl-3 pr-3 pb-2 wrap" v-if="this.module !== 'sales'">
            <v-flex xs12 md6>
              <v-flex xs12>
                <h4>{{ module === 'offer' ? $t('message.orders.standardOfferText') : $t('message.orders.standardOrderText') }}:</h4>
              </v-flex>
              <v-flex xs12>
                <ckeditor :editor="editor" v-model="modelObj.standardsales" :config="editorConfig"></ckeditor>
              </v-flex>
              <v-flex xs12>
                <h4>{{ $t('message.orders.invoiceComments') }}:</h4>
              </v-flex>
              <v-flex xs12>
                <v-textarea dense outlined v-model="modelObj.invoicecomments" hide-details rows="3" auto-grow></v-textarea>
              </v-flex>
              <v-flex xs12>
                <h4>{{ $t('message.whOrder.internalCom') }}:</h4>
              </v-flex>
              <v-flex xs12>
                <v-textarea dense outlined v-model="modelObj.internalcomments" hide-details rows="2" auto-grow></v-textarea>
              </v-flex>
              <!-- <v-flex xs12>
                <h4>{{ $t('message.whOrder.warehouseCom') }}:</h4>
              </v-flex>
              <v-flex xs12>
                <v-textarea dense outlined v-model="modelObj.warehousecomments" hide-details rows="2" auto-grow></v-textarea>
              </v-flex> -->
            </v-flex>
            <v-flex xs12 md6 v-bind:class="{'pl-2': isMdLgScreen}">
              <v-flex xs12>
                <h4>{{ $t('message.orders.standardDeliveryTerms') }}:</h4>
              </v-flex>
              <v-flex xs12>
                <ckeditor :editor="editor" v-model="modelObj.deliveryterms" :config="editorConfig"></ckeditor>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-progress-linear
            rounded
            v-if="loadingProduct"
            height="6"
            class="mt-2"
            indeterminate
            color="primary"
          ></v-progress-linear>
          <order-history v-if="modelObj.id"
            :listOfHistories="listOfHistories"
            :loadingHis="historyLoading"
            @downloadInvoice="$parent ? $parent.downloadOrder : false"
          ></order-history>
        </template>
      </form-data>
    </template>
    <v-dialog v-model="contactDialog" width="800" persistent>
      <form-data
        :references.sync="contactReference"
        :model="contactModel"
        ref="contactReference"
      ></form-data>
    </v-dialog>
    <v-dialog v-model="addressDialog" width="800" persistent>
      <form-data
        :references.sync="addressReference"
        :model="addressModel"
        ref="addressReference"
      ></form-data>
    </v-dialog>
    <!-- Offer accepted confirmation! -->
    <v-dialog v-model="offerCreation.dialog" persistent width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $t('message.common.warning') }}
        </v-card-title>
        <v-card-text class="pa-5">
          <h3 class="mt-2">
            {{
              offerCreation.createdAlready
                ? $t('message.orders.orderHasBeenCreated')
                : $t('message.order.offerAccepted')
            }}
          </h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :loading="offerCreation.loading"
            @click="createOrderFromOffer"
            >{{ $t('message.common.yes') }}
          </v-btn>
          <v-btn color="error" @click="offerCreation.dialog = false">{{
            $t('message.common.no')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--folder template dialog-->
    <v-dialog v-model="folderTemplateDialog" width="600" persistent>
      <v-card>
        <v-card-title>{{$t('message.document.chooseTemplate')}} </v-card-title>
        <v-divider></v-divider>
        <v-progress-linear :active="folderTemplateDialogLoader" indeterminate></v-progress-linear>
        <v-row>
          <v-col cols="12" sm="6" md="6">
        <v-radio-group v-model="selectedFolderTemplate" class="ml-5">
          <v-radio v-for="n in folderTemplates" :key="n.id" :label="`${n.name}`" :value="n.id"></v-radio>
        </v-radio-group>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-flex class="text-center">
            <v-btn color="primary" @click="saveUpdateHandler(SAVE, true)" class="mb-2 ml-3" :loading="folderTemplateSubmitBtnLoading">{{$t('message.orders.createSales')}}</v-btn>
            <v-btn color="info" @click="closeFolderTemplateDialog(false)" class="mb-2 ml-3">{{$t('message.orders.createSalesWithoutTemp')}}</v-btn>
            <v-btn color="error" @click="closeFolderTemplateDialog(true)" class="mb-2 ml-3">{{$t('message.common.close')}}</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '../../components/FormTemplate'
import Customer from '../../mixins/Customer/index'
import CONSTANTS from '../../utils/order.json'
import Editor from '@/ckeditor'
export default {
  data () {
    return {
      fieldsLoading: false,
      salesId: +(this.$route.query.salesid || 0),
      ticketId: 0,
      modelObj: {
        id: this.$route.params.order_id,
        customerid: +(this.$route.query.customerid || 0),
        contactid: 0,
        deliveryaddress: 0,
        invoicedeliveryaddress: 0,
        paymentterms: 0,
        offerDatePicker: '',
        standardsales: '',
        deliveryterms: '',
        shipDatePicker: ''
      },
      modelBakObj: {},
      isOneProductPicked: false,
      loading: false,
      MODULE_URL: 'orders',
      contactsLoading: false,
      contactDialog: false,
      addressDialog: false,
      addressLoading: false,
      invoiceAddressLoading: false,
      loadingProduct: false,
      contactModel: {},
      addressModel: {},
      listOfAddress: [],
      listOfInvoiceAddress: [],
      listOfContacts: [],
      listOfProducts: [],
      allCustomers: [],
      orderStatus: '',
      totalCalculation: {
        totalExVat: '0,00',
        total: '0,00'
      },
      canClear: false,
      canInvoiceClear: false,
      reRender: 0,
      listOfHistories: [],
      customerPriorityId: 0,
      module: this.$route.query.type || '',
      offerCreation: {
        dialog: false
      },
      downloadLoading: false,
      relatedRecords: [],
      paymentMethodTwo: [
        { text: this.$t('message.invoice.saveAndEmail'), id: 1 }
      ],
      isLoading: false,
      cityList: [],
      usersList: [],
      customersLoading: false,
      vatLoading: false,
      isProductionAllowedCustomer: false,
      historyLoading: false,
      editor: Editor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'undo',
            'redo'
          ]
        }
      },
      salesNumberLoading: false,
      folderTemplateDialog: false,
      folderTemplateDialogLoader: false,
      folderTemplateSubmitBtnLoading: false,
      selectedFolderTemplate: null,
      folderTemplates: []
    }
  },
  components: {
    'form-data': FormTemplate,
    'order-history': () => import('../../components/Order/History')
  },
  mixins: [Customer],
  computed: {
    ...mapState([
      'FORM_TYPE',
      'listofCustomerShipments',
      'listOfUsers',
      'listOfPaymentTerms',
      'listOfDeliveryTerms'
    ]),
    isMdLgScreen () {
      return this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl
    },
    email_menu () {
      return this.$store.state.isChangesMade
    },
    formReferences () {
      return {
        title: this.$route.params.order_id
          ? ''
          : `${this.$t('message.common.add')} ${this.$t(
            `message.layout.${this.module}`
          )}`,
        properties: [
          {
            model: 'customerid',
            type: this.FORM_TYPE.AUTO_COMPLETE,
            items: this.allCustomers,
            term: 'customer',
            loading: this.customersLoading,
            click: term => false,
            change: () => this.getCustomerRelatedData(),
            is_list: false,
            select_text: 'customerwithcity',
            select_value: 'id',
            rules: this.$_requiredValidation,
            class: 'lg3 sm6 xs12',
            label: this.$t('message.order.customer'),
            item_disabled: this.isCustomerDisabled,
            custom_item_slot: true
          },
          {
            model: 'deliveryaddress',
            type: this.FORM_TYPE.AUTO_COMPLETE,
            items: this.listOfAddress,
            term: '',
            click: term => this.addNewAddress('delivery'),
            is_list: true,
            select_text: 'address_data',
            select_value: 'id',
            class: 'lg3 sm6 xs12',
            label: this.$t('message.orders.deliveryAddress'),
            change: this.changesMade,
            is_visible: this.module !== 'sales'
          },
          {
            model: 'invoiceto',
            type: this.FORM_TYPE.AUTO_COMPLETE,
            items: this.allCustomers,
            term: 'invoiceto',
            click: term => false,
            change: () => this.invoiceToRelated(),
            is_list: false,
            select_text: 'name',
            select_value: 'id',
            class: 'lg3 sm6 xs12',
            label: this.$t('message.orders.invoiceTo'),
            is_visible: this.module !== 'sales',
            item_disabled: this.isCustomerDisabled,
            custom_item_slot: true
          },
          {
            model: 'invoicedeliveryaddress',
            type: this.FORM_TYPE.AUTO_COMPLETE,
            items: this.listOfInvoiceAddress,
            term: 'invoiceaddress',
            click: term => this.addNewAddress('invoice'),
            loading: this.invoiceAddressLoading,
            is_list: true,
            select_text: 'address_data',
            select_value: 'id',
            class: 'lg3 sm6 xs12',
            label: this.$t('message.order.invoiceDeliveryAddress'),
            change: this.changesMade,
            is_visible: this.module !== 'sales'
          },
          {
            model: 'salesreference',
            type: this.FORM_TYPE.TEXT,
            loading: this.salesNumberLoading,
            rules: !this.modelObj.id ? this.$_requiredValidation : [],
            label: this.$t('message.orders.salesReference'),
            class: 'lg3 sm6',
            change: this.changesMade
          },
          {
            model: 'contactid',
            type: this.FORM_TYPE.AUTO_COMPLETE,
            items: this.listOfContacts,
            term: '',
            rules: this.module === 'order' ? this.$_requiredValidation : [],
            click: term => this.addNewContact(term),
            is_list: true,
            loading: this.contactsLoading,
            select_text: 'name',
            select_value: 'id',
            class: 'lg3 sm6 xs12',
            label: this.$t('message.orders.customercontact'),
            change: this.changesMade
          },
          {
            model: 'yourreference',
            type: this.FORM_TYPE.TEXT,
            rules: [],
            label: this.$t('message.orders.yourReference'),
            class: 'lg2 sm6',
            change: this.changesMade
          },
          {
            model: 'yourordernumber',
            type: this.FORM_TYPE.TEXT,
            rules: [],
            label: this.$t('message.orders.yourOrderNumber'),
            class: 'lg2 sm6',
            change: this.changesMade
          },
          {
            model: 'ourreference',
            type: this.FORM_TYPE.AUTO_COMPLETE,
            items: this.usersList,
            term: 'ourreference',
            click: term => false,
            is_list: false,
            select_text: 'name',
            select_value: 'id',
            class: 'lg2 sm6 xs12',
            label: this.$t('message.orders.ourReference'),
            change: this.changesMade
          },
          {
            model: 'state',
            type: this.FORM_TYPE.SELECT,
            rules: [],
            label: this.$t('message.tickets.status'),
            items: this.statusList,
            select_text: 'name',
            select_value: 'id',
            class: 'lg2 sm6 md3',
            change: this.updateProbability
          },
          {
            model: 'probability',
            type: this.FORM_TYPE.TEXT,
            rules: this.modelObj.probability ? this.$_discountValidation : [],
            label: this.$t('message.order.probability'),
            class: 'lg1 sm6 md3',
            change: this.changesMade,
            append_icon: 'mdi-18px mdi-percent',
            is_visible: this.module === 'offer'
          },
          {
            model: 'orderdate',
            rules: this.module === 'order' ? this.$_requiredValidation : [],
            type: this.FORM_TYPE.DATEPICKER,
            class: 'lg2 sm6 md3 xs12',
            picker: 'orderDatePicker',
            menu: 'orderDateMenu',
            color: 'primary lighten-1',
            label: this.$t('message.orders.orderDate'),
            change: this.changesMade,
            is_visible: this.module !== 'sales'
          },
          {
            model: 'labeled',
            type: this.FORM_TYPE.TEXT,
            class: 'lg2 sm6 xs12',
            label: this.$t('message.whOrder.labeled'),
            change: this.changesMade
          },
          // {
          //   model: 'responsible',
          //   type: this.FORM_TYPE.AUTO_COMPLETE,
          //   items: this.listOfUsers,
          //   term: 'responsible',
          //   click: term => false,
          //   rules: this.$_requiredValidation,
          //   is_list: false,
          //   select_text: 'fullname',
          //   select_value: 'id',
          //   class: 'lg2 sm6 xs12',
          //   label: this.$t('message.deviations.responsible'),
          //   change: this.changesMade
          // },
          {
            model: 'shipment',
            type: this.FORM_TYPE.AUTO_COMPLETE,
            items: this.listofCustomerShipments,
            term: 'shipment',
            click: () => false,
            select_text: 'name',
            select_value: 'id',
            class: 'lg2 sm6 md3 xs12',
            label: this.$t('message.customer.shipment'),
            change: this.changesMade,
            is_visible: this.module !== 'sales'
          },
          {
            model: 'salesdate',
            rules: this.$_requiredValidation,
            type: this.FORM_TYPE.DATEPICKER,
            class: 'lg2 sm6 md3 xs12',
            picker: 'saleDatePicker',
            menu: 'saledateMenu',
            color: 'primary lighten-1',
            label: this.$t('message.orders.salesDate'),
            change: this.changesMade,
            is_visible: this.module === 'sales'
          },
          {
            model: 'salesvalue',
            type: this.FORM_TYPE.TEXT,
            rules: this.modelObj.salesvalue ? this.$_norwegianNumberMinusValidation : [],
            label: this.$t('message.orders.salesValue'),
            class: 'lg2 sm6 md3',
            change: this.changesMade,
            is_visible: this.module === 'sales'
          },
          {
            model: 'offerdate',
            rules: this.module === 'offer' ? this.$_requiredValidation : [],
            type: this.FORM_TYPE.DATEPICKER,
            class: 'lg2 sm6 md3 xs12',
            picker: 'offerDatePicker',
            menu: 'dateMenu',
            color: 'primary lighten-1',
            label: this.$t('message.orders.offerDate'),
            change: this.changesMade,
            is_visible: this.module !== 'sales'
          },
          {
            model: 'offerduedate',
            type: this.FORM_TYPE.SELECT,
            rules: [],
            items: this.dueDates,
            select_text: 'text',
            select_value: 'value',
            class: 'lg1 sm6 md3',
            label: this.$t('message.orders.offerDueDate'),
            change: this.changesMade,
            is_visible: this.module !== 'sales'
          },
          {
            model: 'deliverytime',
            rules: [],
            type: this.FORM_TYPE.TEXT,
            class: 'lg2 sm6 md3 xs12',
            color: 'primary lighten-1',
            label: this.$t('message.orders.deliveryTime'),
            change: this.changesMade,
            is_visible: this.module !== 'sales'
          },
          {
            model: 'sendfrom_warehouse',
            label: this.$t('message.orders.sendFromWH'),
            change: this.changesMade,
            type: this.FORM_TYPE.TEXT,
            rules: this.$_weekValidation,
            class: 'lg2 sm6 md3'
          },
          // {
          //   model: 'shipdate',
          //   rules: [],
          //   type: this.FORM_TYPE.DATEPICKER,
          //   class: 'lg2 sm6 md3 xs12',
          //   picker: 'shipDatePicker',
          //   menu: 'shipDateMenu',
          //   color: 'primary lighten-1',
          //   label: this.$t('message.orders.shipDate'),
          //   change: this.changesMade,
          //   is_visible: this.module !== 'sales'
          // },
          {
            model: 'installation_week',
            type: this.FORM_TYPE.TEXT,
            rules: this.$_weekValidation,
            label: this.$t('message.orders.installationWeek'),
            class: 'lg2 sm6 md3',
            change: this.changesMade
          }, {
            model: 'installation_completed',
            rules: [],
            type: this.FORM_TYPE.DATEPICKER,
            class: 'lg2 sm6 md3 xs12',
            picker: 'installCompleteDatePicker',
            menu: 'installCompleteDateMenu',
            color: 'primary lighten-1',
            label: this.$t('message.orders.installationCompleted'),
            change: this.changesMade
          },
          {
            model: 'paymentterms',
            type: this.FORM_TYPE.AUTO_COMPLETE,
            rules: [],
            label: this.$t('message.order.paymentTerm'),
            items: this.listOfPaymentTerms,
            term: 'paymentterms',
            click: () => false,
            select_text: 'name',
            select_value: 'days',
            class: 'lg2 sm6 md3',
            change: this.changesMade,
            is_visible: this.module !== 'sales'
          },
          {
            model: 'deliveryterms_id',
            type: this.FORM_TYPE.AUTO_COMPLETE,
            rules: [],
            label: this.$t('message.order.deliveryTerm'),
            items: this.listOfDeliveryTerms,
            term: 'deliveryterms_id',
            click: () => false,
            select_text: 'name',
            select_value: 'id',
            class: 'lg2 sm3 md3',
            change: this.changesMade,
            is_visible: this.module !== 'sales'
          },
          {
            model: 'paymentmethod1',
            type: this.FORM_TYPE.SELECT,
            rules: this.$_requiredValidation,
            label: `${this.$t('message.customer.paymentmethod')}`,
            items: this.paymentMethod1,
            select_text: 'text',
            select_value: 'value',
            class: 'lg2 sm3 md3',
            change: this.changesMade,
            is_visible: this.module !== 'sales'
          },
          {
            model: 'paymentmethod2',
            type: this.FORM_TYPE.AUTO_COMPLETE,
            rules: [],
            label: `${this.$t('message.customer.invoicetype')}`,
            items: this.paymentMethodTwo,
            loading: this.vatLoading,
            select_text: 'text',
            select_value: 'id',
            class: 'lg2 sm3 md3',
            change: this.changesMade,
            is_visible: this.module !== 'sales'
          },
          {
            model: 'isproductionorder',
            rules: [],
            type: this.FORM_TYPE.CHECKBOX,
            class: 'lg2 sm4 my-auto',
            label: this.$t('message.order.productionOrder'),
            is_visible: this.module !== 'sales' && this.isProductionAllowedCustomer,
            disabled: !!this.modelBakObj.isproductionorder && this.isOneProductPicked,
            change: this.changesMade
          },
          {
            model: 'storesales',
            rules: [],
            type: this.FORM_TYPE.CHECKBOX,
            class: 'lg2 sm3 my-auto',
            label: this.$t('message.orders.storeSales'),
            change: this.changesMade,
            is_visible: this.module !== 'sales'
          },
          {
            slot: 'related_records',
            model: 'related_records'
          }
        ],
        buttons: [
          {
            name: 'action_handler',
            color: 'success',
            label: this.$route.params.order_id
              ? this.$t('message.common.update')
              : this.$t('message.common.save'),
            click: () => this.saveUpdateHandler(this.SAVE),
            loading: this.loading,
            is_show: true
          },
          {
            name: 'close_handler',
            color: 'primary',
            label: this.$t('message.common.updateAndClose'),
            click: () => this.saveUpdateHandler(this.UPDATE_CLOSE),
            loading: this.loading,
            is_show: this.$route.params.order_id
          },
          {
            name: 'back_to_list',
            color: 'info',
            // eslint-disable-next-line
            click: () => this.$router.go(-1),
            label: this.$t('message.common.backToList'),
            is_show: true
          },
          {
            name: 'delete_btn',
            color: 'error',
            label: this.$t('message.common.delete'),
            click: this.deleteHandler,
            is_show: this.$route.params.order_id && this.$parent.canDeleteOrder
          }
        ]
      }
    },
    statusList () {
      let statusList = this.$formatter.cloneVariable(this.$_orderOfferStatus)
      if (this.module === 'sales') {
        statusList = statusList.filter(x => x.issales)
        return statusList
      } else if (this.module === 'offer') {
        statusList = statusList.filter(x => !x.is_order && !x.issales)
        return statusList
      } else {
        statusList = statusList.filter(x => x.is_order)
        if (this.modelObj.state === CONSTANTS.INVOICED) {
          let getIndex = statusList.findIndex(x => x.id === 'cancelled')
          if (getIndex >= 0) statusList.splice(getIndex, 1)
          return statusList
        } else return statusList
      }
    },
    paymentMethod1 () {
      return [
        // { text: this.$t('message.customer.sg'), value: 'sg' },
        { text: this.$t('message.customer.direct'), value: 'direct' }
      ]
    },
    dueDates () {
      return [
        { text: `5 ${this.$t('message.invoice.days')}`, value: 5 },
        { text: `15 ${this.$t('message.invoice.days')}`, value: 15 },
        { text: `30 ${this.$t('message.invoice.days')}`, value: 30 }
      ]
    },
    offerOptions () {
      return [
        {
          text: this.$t('message.common.offerConfirm'),
          value: 1
        }, {
          text: this.$t('message.common.offerWithZone'),
          value: 7
        }
      ]
    },
    reportOptions () {
      return [
        {
          text: this.$t('message.common.orderConfirm'),
          value: 1
        },
        {
          text: this.$t('message.common.orderConfirmWithData'),
          value: 2
        }, {
          text: this.$t('message.order.confirmationWithZone'),
          value: 7
        }, {
          text: this.$t('message.orders.packList'),
          value: 3
        }, {
          text: this.$t('message.order.purchaseList'),
          value: 6
        }
      ]
    }
  },
  watch: {
    'modelObj.offerDatePicker' (val) {
      if (val) {
        this.modelObj.offerdate = this.$formatter.formatDate(
          val,
          'YYYY-MM-DD',
          'DD.MM.YYYY'
        )
      }
    },
    'modelObj.shipDatePicker' (val) {
      if (val) {
        this.modelObj.shipdate = this.$formatter.formatDate(
          val,
          'YYYY-MM-DD',
          'DD.MM.YYYY'
        )
      }
    },
    'modelObj.saleDatePicker' (val) {
      if (val) {
        this.modelObj.salesdate = this.$formatter.formatDate(
          val,
          'YYYY-MM-DD',
          'DD.MM.YYYY'
        )
      }
    },
    'modelObj.orderDatePicker' (val) {
      if (val) {
        this.modelObj.orderdate = this.$formatter.formatDate(
          val,
          'YYYY-MM-DD',
          'DD.MM.YYYY'
        )
      }
    },
    'modelObj.deliveryDatePicker' (val) {
      if (val) {
        this.modelObj.deliverydate = this.$formatter.formatDate(
          val,
          'YYYY-MM-DD',
          'DD.MM.YYYY'
        )
      }
    },
    'modelObj.installCompleteDatePicker' (val) {
      if (val) {
        this.modelObj.installation_completed = this.$formatter.formatDate(
          val,
          'YYYY-MM-DD',
          'DD.MM.YYYY'
        )
      }
    }
  },
  async mounted () {
    /* if offer is created from ticket then set selected values */
    if ((this.module === CONSTANTS.OFFER || this.module === CONSTANTS.SALES) && this.$route.query.fromticket) { // Creating Sale from ticket
      setTimeout(() => {
        this.ticketId = 0
        let values = JSON.parse(decodeURIComponent(this.$route.query.fromticket))
        if (values) {
          if (values.resposible) this.modelObj.responsible = values.resposible
          if (values.customer) {
            this.modelObj.customerid = values.customer
            this.ticketId = values.ticketid
            this.getCustomerRelatedData()
          }
        }
      }, 500)
    }
    if (!this.modelObj.id) {
      if (!this.salesId) {
        this.getSalesReference()
      }
      await this.getCustomersList()
      this.$store.dispatch('getUsers')
        .then((result) => {
          this.usersList = result
          this.usersList.map(x => {
            let referenceDetail = [x.firstname || '', x.lastname || '']
            x.name = referenceDetail.filter(y => y).join(' ')
            return x
          })
        })
      this.modelObj.offerduedate = 30
      this.modelObj.deliverytime = '6 arb.uker'
      this.modelObj.state = this.module === CONSTANTS.OFFER ? CONSTANTS.NEW : CONSTANTS.FOR_PRODUCTION
      if (this.module === CONSTANTS.OFFER && this.modelObj.state === CONSTANTS.NEW) {
        this.modelObj.probability = '20'
      }
      if (this.module === 'offer') {
        this.modelObj.offerdate = this.$_getCurrentDate()
        this.modelObj.paymentmethod1 = 'direct'
      } else if (this.module === 'sales') {
        this.modelObj.salesdate = this.$_getCurrentDate()
        this.modelObj.state = CONSTANTS.REQUEST
      } else if (this.module === 'order') {
        this.modelObj.orderdate = this.$_getCurrentDate()
      }

      if (!this.salesId) {
        this.modelObj.responsible = this.$store.state.userDetails && this.$store.state.userDetails.id !== -100
          ? this.$store.state.userDetails.id
          : ''
        this.modelObj.ourreference = this.$store.state.userDetails
          ? this.$store.state.userDetails.id
          : ''
      } else {
        /* if order/offer created from sales */
        const salesId = this.salesId || 0
        if (salesId) {
          this.$_executeApi('get', `orders/${salesId}`)
            .then((res) => {
              const salesOrder = res.data || {}
              let transformData = {
                date: {
                  list: ['orderdate', 'offerdate', 'deliverydate', 'salesdate', 'installation_completed', 'shipdate'],
                  from: 'DD.MM.YYYY',
                  to: 'DD.MM.YYYY'
                }
              }
              let model = this.$_formatModel(salesOrder, transformData)
              model.source_ref = salesId
              model.id = 0
              model.number = 0
              model.sharepoint_id = ''
              model.sharepoint_link = ''
              if (this.module === 'offer') {
                model.offerdate = model.salesdate
                model.paymentmethod1 = 'direct'
              } else if (this.module === 'order') {
                model.orderdate = model.salesdate
              }
              model.offerduedate = 30
              model.state = this.module === CONSTANTS.OFFER ? CONSTANTS.NEW : CONSTANTS.FOR_PRODUCTION
              this.modelObj = model
              this.getCustomerRelatedData(model.contactid)
            })
        }
      }
      this.getSettings()
    } else {
      this.getCustomersList().then(() => {
        this.getSingleRecordHandler()
      })
    }
    this.$store.dispatch('getCustomerShipment').then(response => {
      if (!this.modelObj.id) {
        this.setDefaultValues({
          prop: 'shipment',
          list: this.listofCustomerShipments
        })
      }
    })

    let text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteSuccess', data => {
      if (data === this.MODULE_URL) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.$router.push(`/${this.MODULE_URL}`)
      }
    })
    this.$eventBus.$on('downloadLoading', data => {
      this.downloadLoading = data
    })
    this.$eventBus.$on('showRelatedItems', data => {
      const records = data
      this.relatedRecords = records || []
    })
    this.$eventBus.$on('loadOffer', () => {
      this.modelObj.id = this.$route.params.order_id
      this.getSingleRecordHandler()
    })
    this.$eventBus.$on('loadHistory', () => {
      this.modelObj.id = this.$route.params.order_id
      this.getListOfHistory()
    })
    this.$eventBus.$on('saveUpdateHandler', () => {
      this.saveUpdateHandler(this.SAVE)
    })
    this.$store.dispatch('getPaymentTerms', this.$t('message.common.days'))
    this.$store.dispatch('getDeliveryTerms')
    this.$eventBus.$on('setItemInField', (data) => {
      let model = Object.assign({ ...this.modelObj }, { [data.modelName]: data.recordId })
      this.modelObj = model
    })
    if (this.$route.query.customerid) this.getCustomerRelatedData()
  },
  methods: {
    checkChangeBeforeAction (isDownload) {
      if (this.$store.state.isChangesMade) {
        this.$store.commit('isChangesMade', true)
        this.$store.commit('changeSaveUpdateDialog', true)
      } else {
        // if (!(this.modelObj.type === 'order') && !(this.modelObj.type === 'rest_order')) {
        //   if (isDownload) {
        //     this.downloadOrder(1)
        //   } else this.shareOrder(1)
        // }
      }
    },
    isCustomerDisabled (item) {
      return !item.isactive
    },
    getCustomersList () {
      this.customersLoading = true
      return this.$_executeApi('get', 'customers/customer_with_address')
        .then(response => {
          this.allCustomers = response.data || []
        })
        .finally(() => {
          this.customersLoading = false
        })
    },
    getCustomerRelatedData (contactId = 0) {
      this.changesMade()
      this.modelObj.invoiceto = this.modelObj.customerid
      this.modelObj.isproductionorder = false
      let getCustomerObj = this.allCustomers.find(
        x => x.id === this.modelObj.customerid
      )
      if (getCustomerObj) {
        this.customerPriorityId = getCustomerObj.priority || 0
        this.isProductionAllowedCustomer = getCustomerObj.productionallowed || false
      }
      this.getPaymentTerm(this.modelObj.invoiceto || 0)
      this.getContacts(contactId)
      this.getAddresses(0)
      this.getInvoiceAddresses(0)
    },
    setDefaultValues (data) {
      let { list, prop } = data
      let item = list.find(x => x.isdefault)
      if (item) {
        let model = Object.assign({ ...this.modelObj }, { [prop]: item.id })
        this.modelObj = model
      }
    },
    getAddresses (id) {
      if (this.modelObj.customerid) {
        this.addressLoading = true
        let query = { filter: `customer_id eq ${this.modelObj.customerid}`, order_by: { field: 'address', asc_or_desc: 'asc' } }
        this.$_executeApi('post', `customeraddresses/query`, query)
          .then(response => {
            let address = response.data
            let deliveryAddress = address.filter(x => x.type === 'delivery')
            if (!this.modelObj.id || this.canClear) { this.modelObj.deliveryaddress = 0 }
            if (!this.modelObj.id && deliveryAddress && deliveryAddress.length === 1) {
              this.modelObj.deliveryaddress = deliveryAddress[0].id
            }
            let addresses = response.data

            let storedDeliveryAddress = this.modelObj.ordercustomerdeliveryaddressdata ? JSON.parse(this.modelObj.ordercustomerdeliveryaddressdata) : {}
            if (storedDeliveryAddress && storedDeliveryAddress.Id > 0) {
              storedDeliveryAddress = Object.fromEntries(Object.entries(storedDeliveryAddress).map(([k, v]) => [k.toLowerCase(), v]))
              addresses.push(storedDeliveryAddress)
            }

            if (addresses) {
              addresses.map(x => {
                let data = [x.address || '', x.address2 || '', x.postcode || '', x.city || '']
                data = data.filter(y => y)
                x.address_data = data.join(', ')
              })
            }
            this.listOfAddress = addresses
            if (this.modelObj.id && this.modelObj.deliveryaddress && this.modelObj.ordercustomerdeliveryaddressdata) {
              let deliveryAddressData = this.modelObj.ordercustomerdeliveryaddressdata ? JSON.parse(this.modelObj.ordercustomerdeliveryaddressdata) : {}
              this.listOfAddress.map(x => {
                if (x.id === this.modelObj.deliveryaddress) {
                  let addressDetails = [deliveryAddressData.Address || '', deliveryAddressData.Address2 || '', deliveryAddressData.PostCode || '', deliveryAddressData.City || '']
                  x.address_data = addressDetails.filter(y => y).join(', ')
                }
                return x
              })
            }
            if (this.modelObj.id) this.canClear = true
            if (id) this.modelObj.deliveryaddress = id
          })
          .finally(() => {
            this.addressLoading = false
          })
      } else {
        this.listOfAddress = []
        this.modelObj.deliveryaddress = 0
      }
    },
    invoiceToRelated () {
      this.getPaymentTerm(this.modelObj.invoiceto)
      this.getInvoiceAddresses(0)
    },
    getInvoiceAddresses (id) {
      this.listOfInvoiceAddress = []
      if (!id) this.modelObj.invoicedeliveryaddress = 0
      if (!id && this.modelObj.invoicedeliveryaddress) id = this.modelObj.invoicedeliveryaddress
      if (this.modelObj.invoiceto) {
        this.invoiceAddressLoading = true
        let query = { filter: `customer_id eq ${this.modelObj.invoiceto} AND type eq 'invoice'`, order_by: { field: 'address', asc_or_desc: 'asc' } }
        this.$_executeApi('post', `customeraddresses/query`, query)
          .then(response => {
            let address = response.data
            if (!this.modelObj.id || this.canInvoiceClear) { this.modelObj.invoicedeliveryaddress = 0 }
            if (!this.modelObj.id && address && address.length === 1) { this.modelObj.invoicedeliveryaddress = address[0].id }
            let storedInvoiceAddress = this.modelObj.orderinvoicetoaddressdata ? JSON.parse(this.modelObj.orderinvoicetoaddressdata) : {}
            if (storedInvoiceAddress && storedInvoiceAddress.Id > 0) {
              storedInvoiceAddress = Object.fromEntries(Object.entries(storedInvoiceAddress).map(([k, v]) => [k.toLowerCase(), v]))
              address.push(storedInvoiceAddress)
            }
            if (address) {
              address.map(x => {
                let data = [x.address || '', x.address2 || '', x.postcode || '', x.city || '']
                x.address_data = data.filter(x => x).join(', ')
              })
            }

            this.listOfInvoiceAddress = address

            if (this.modelObj.id && this.modelObj.invoicedeliveryaddress && this.modelObj.orderinvoicetoaddressdata) {
              let invoiceAddressData = this.modelObj.orderinvoicetoaddressdata ? JSON.parse(this.modelObj.orderinvoicetoaddressdata) : {}
              this.listOfInvoiceAddress.map(x => {
                if (x.id === this.modelObj.invoicedeliveryaddress) {
                  let addressDetails = [invoiceAddressData.Address || '', invoiceAddressData.Address2 || '', invoiceAddressData.PostCode || '', invoiceAddressData.City || '']
                  x.address_data = addressDetails.filter(y => y).join(', ')
                }
                return x
              })
            }
            if (this.modelObj.id) this.canInvoiceClear = true
            if (id) this.modelObj.invoicedeliveryaddress = id
          })
          .finally(() => {
            this.invoiceAddressLoading = false
          })
      } else {
        this.listOfInvoiceAddress = []
        this.modelObj.invoicedeliveryaddress = 0
      }
    },
    getContacts (id) {
      if (this.modelObj.customerid) {
        this.contactsLoading = true
        let query = { filter: `customer_id eq ${this.modelObj.customerid}`, order_by: { field: 'firstname', asc_or_desc: 'asc' } }
        this.$_executeApi('post', `contacts/query`, query)
          .then(response => {
            let list = response.data
            list.map(x => {
              x.name = `${x.firstname || ''} ${x.lastname || ''}, ${x.mobilephone || ''}`
              return x
            })
            if (!this.modelObj.id || this.canClear) this.modelObj.contactid = 0
            this.listOfContacts = list
            if (this.modelObj.id && this.modelObj.contactid && this.modelObj.ordercustomercontactdata) {
              let contactData = this.modelObj.ordercustomercontactdata ? JSON.parse(this.modelObj.ordercustomercontactdata) : {}
              this.listOfContacts.map(x => {
                if (x.id === this.modelObj.contactid) {
                  x.name = `${contactData.FirstName || ''} ${contactData.LastName || ''} ${contactData.MobilePhone ? ', ' + contactData.MobilePhone : ''}` // contactDetail.filter(y => y).join(' ')
                }
                return x
              })
            }
            if (id) this.modelObj.contactid = id
          })
          .finally(() => {
            this.contactsLoading = false
          })
      } else {
        this.listOfContacts = []
        this.modelObj.contactid = 0
      }
    },
    getSingleRecordHandler () {
      this.fieldsLoading = true
      let query = {
        expand: [
          {
            select: ['number', 'type'],
            model: 'Order',
            on_field: 'id',
            on_parent_field: 'source_ref'
          }
        ],
        filter: `id eq ${this.modelObj.id}`
      }
      this.$_executeApi('post', `${this.MODULE_URL}/query`, query)
        .then(result => {
          let transformData = {
            date: {
              list: ['orderdate', 'offerdate', 'deliverydate', 'salesdate', 'installation_completed', 'shipdate'],
              from: 'DD.MM.YYYY',
              to: 'DD.MM.YYYY'
            },
            number: {
              list: ['totalsum', 'totalexvat'],
              format: 'replaceDotWithComma'
            }
          }
          result.data = result.data[0] || {}
          let model = this.$_formatModel(result.data, transformData)
          model.paymentmethod2 = +model.paymentmethod2
          model.offerduedate = +model.offerduedate
          if (!model.standardsales) model.standardsales = ''
          if (!model.deliveryterms) model.deliveryterms = ''
          this.module = model.type
          if (result.data) {
            if (model.ordercustomerdata && model.customerid) {
              let customerData = JSON.parse(model.ordercustomerdata)
              let customerAddressData = model.ordercustomerdeliveryaddressdata ? JSON.parse(model.ordercustomerdeliveryaddressdata) : {}
              this.allCustomers.map(x => {
                if (x.id === model.customerid) {
                  let customerDetails = [customerData.Name || '', customerAddressData.City || '', customerData.Custom_Number || '']
                  x.customerwithcity = customerDetails.filter(y => y).join(', ')
                }
                return x
              })
            }
            if (model.orderinvoicetodata && model.invoiceto) {
              let invoiceToData = model.orderinvoicetodata ? JSON.parse(model.orderinvoicetodata) : {}
              this.allCustomers.map(x => {
                if (x.id === model.invoiceto) {
                  x.name = invoiceToData.Name
                }
                return x
              })
            }
            this.modelObj = model
            this.modelBakObj = this.$formatter.cloneVariable(model)
            this.orderStatus = model.state
            this.canClear = false
            this.canInvoiceClear = false
            let getCustomerObj = this.allCustomers.find(
              x => x.id === this.modelObj.customerid
            )
            this.customerPriorityId = getCustomerObj
              ? getCustomerObj.priority
              : 0
            this.isProductionAllowedCustomer = getCustomerObj ? getCustomerObj.productionallowed : false
            this.getPaymentTerm(model.invoiceto, true)
          }
          this.getContacts(this.modelObj.contactid || 0)
          this.getAddresses(this.modelObj.deliveryaddress || 0)
          this.getListOfHistory()
          this.checkIfAtleastOneProductPicked()
          this.getInvoiceAddresses(model.invoicedeliveryaddress || 0)
          // getting users
          this.$store.dispatch('getUsers')
            .then((result) => {
              if (this.modelObj.id) {
                let detailsData = this.modelObj.orderourreferencedata ? JSON.parse(this.modelObj.orderourreferencedata) : {}
                this.usersList = result
                this.usersList.map(x => {
                  if (x.id === this.modelObj.ourreference && this.modelObj.orderourreferencedata) {
                    let referenceDetail = [detailsData.FirstName || '', detailsData.LastName || '']
                    x.name = referenceDetail.filter(y => y).join(' ')
                  } else {
                    let referenceDetail = [x.firstname || '', x.lastname || '']
                    x.name = referenceDetail.filter(y => y).join(' ')
                  }
                  return x
                })
              }
            })
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    checkIfAtleastOneProductPicked () {
      this.isOneProductPicked = false
      this.$_executeApi('get', `orders/check_if_a_product_picked/${this.modelObj.id}`)
        .then((response) => {
          if (response && response.data) this.isOneProductPicked = true
        })
    },
    getListOfHistory () {
      this.historyLoading = true
      let query = {
        expand: [
          {
            select: ['firstname', 'lastname'],
            model: 'User',
            on_field: 'id',
            on_parent_field: 'createdby'
          }
        ],
        order_by: {
          field: 'createdon',
          asc_or_desc: 'desc'
        },
        filter: `orderid eq '${this.modelObj.id}'`
      }
      const orderHisQuery = this.$formatter.cloneVariable(query)
      orderHisQuery.expand.push({
        select: ['number'],
        model: 'Order',
        on_field: 'id',
        on_parent_field: 'saleid'
      })
      this.$_executeApi('post', `orderhistories/query`, orderHisQuery).then(
        response => {
          let list = response.data
          let status = this.$formatter.cloneVariable(this.$_orderOfferStatus)
          list.map(x => {
            x.firstname = x.createdby === -100 ? 'SuperAdmin' : `${x.user_firstname || ''} ${x.user_lastname || ''}`
            let getState = status.find(y => y.id === x.status)
            if (getState) {
              x.state = getState ? getState.name : ''
            } else {
              x.state = x.status
            }
          })
          this.listOfHistories = list
          // Add commercialinvoices as histories
          this.$_executeApi('post', `commercialinvoices/query`, query).then(
            response => {
              let createdInvoices = response.data
              if (createdInvoices) {
                for (let i = 0; i < createdInvoices.length; i++) {
                  let history = {
                    id: createdInvoices[i].id,
                    createdon: createdInvoices[i].createdon,
                    orderid: createdInvoices[i].orderid,
                    state: 'commercial invoice',
                    iscommercialinvoice: true,
                    firstname:
                      createdInvoices[i].createdby === -100
                        ? 'SuperAdmin'
                        : `${createdInvoices[i].user_firstname || ''} ${createdInvoices[i].user_lastname || ''}`
                  }
                  this.listOfHistories.push(history)
                }
              }
            }
          )
          this.historyLoading = false
          this.listOfHistories.sort(x => x.createdon)
        }
      )
    },
    getSupplierByProduct (productId) {
      return new Promise((resolve, reject) => {
        let model = {
          expand: [
            {
              select: ['name'],
              model: 'Customer',
              on_field: 'id',
              on_parent_field: 'supplierid'
            }
          ],
          filter: `productid eq '${productId}'`
        }
        this.$_executeApi('post', 'productsuppliers/query', model)
          .then(response => {
            if (response.data) resolve(response.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    saveUpdateHandler (type, canCreateTemplate = false) {
      if (!this.modelObj.id && this.module === 'sales' && !canCreateTemplate) {
        // show template create action!
        this.showFolderTemplateDialog()
        return
      }
      if (this.$refs.offerReference.$refs.validateForm.validate()) {
        this.loading = true
        let url = `${this.MODULE_URL}?saleId=${this.salesId || 0}&ticketId=${this.ticketId}`
        if (this.modelObj && this.modelObj.id) url = this.MODULE_URL
        let transformData = {
          date: {
            list: ['orderdate', 'offerdate', 'deliverydate', 'salesdate', 'installation_completed', 'shipdate'],
            from: 'DD.MM.YYYY',
            to: 'MM.DD.YYYY'
          },
          number: {
            list: ['totalsum', 'totalexvat'],
            format: 'replaceCommaWithDot'
          }
        }
        let model = this.$_formatModel(this.modelObj, transformData)
        model.type = this.module || ''
        if (!model.sendfrom_warehouse) model.sendfrom_warehouse = null
        if (!model.installation_completed) model.installation_completed = null
        if (!model.probability) model.probability = null
        if (!model.storesales) model.storesales = false
        if (this.folderTemplateDialog) {
          this.folderTemplateSubmitBtnLoading = true
        }
        this.$_saveUpdateHandler(url, model)
          .then(async (response) => {
            if (response && response && response.type === 'offer') {
              this.modelObj.probability = response.probability
            }
            this.$store.commit('isChangesMade', false)
            if (model.id && model.state === CONSTANTS.CREATE_ORDER) {
              this.offerCreation = {
                dialog: true,
                type,
                createdAlready: model.source_ref && model.order_type !== 'sales'
              }
            } else {
              if (canCreateTemplate && this.selectedFolderTemplate && !this.modelObj.id && this.module === 'sales' && response.salereferencesharepoint_id) {
                await this.createFolderTemplate(response.salereferencesharepoint_id)
              }
              this.navigatingHandler(type, model, response)
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'error',
          text: this.$t('message.common.validationIssue')
        })
      }
    },
    navigatingHandler (type, model, response) {
      if (type === this.SAVE && !model.id) { this.$router.push(`/${this.MODULE_URL}/edit/${response.id}/view`) } else if (type === this.UPDATE_CLOSE) { this.$router.push(`/${this.MODULE_URL}`) }
    },
    deleteHandler () {
      let ids = [this.modelObj.id]
      let payload = {
        ids,
        url: `${this.MODULE_URL}/delete_multiple`,
        module: this.MODULE_URL
      }
      this.$store.commit('showDeleteDialog', payload)
    },
    getPaymentTerm (id, isLoad) {
      if (this.allCustomers && this.allCustomers.length > 0) {
        let customer = this.allCustomers.find(x => x.id === id)
        if (customer) {
          if (!isLoad) {
            this.modelObj.paymentterms = customer.paymentterm || 0
            this.modelObj.deliveryterms_id = customer.deliveryterms_id || 0
            this.modelObj.paymentmethod1 = customer.paymentmethod1 ? customer.paymentmethod1.toLowerCase() : ''
            this.modelObj.paymentmethod2 = (customer.paymentmethod2 ? +customer.paymentmethod2 : 0)
          }
          this.verifyVat(customer.vat)
        } else this.modelObj.paymentterms = 0
      }
    },
    addNewContact (term) {
      this.contactDialog = true
      this.contactModel = { isactive: true }
    },
    closeAddNewContact () {
      this.contactDialog = false
      this.contactModel.id = undefined
      this.$refs.contactReference.$refs.validateForm.reset()
    },
    addNewAddress (type) {
      this.addressDialog = true
      this.addressModel = { isstandard: true, type }
    },
    closeAddNewAddress () {
      this.addressDialog = false
      this.addressLoading = false
      this.addressModel.id = undefined
      this.$refs.addressReference.$refs.validateForm.reset()
    },
    saveUpdateContactHandler () {
      if (this.$refs.contactReference.$refs.validateForm.validate()) {
        this.contactLoading = true
        let model = this.contactModel
        model.customer_id = this.modelObj.customerid
        this.$_saveUpdateHandler('contacts', model)
          .then(response => {
            this.contactDialog = false
            this.contactModel.id = undefined
            this.$refs.contactReference.$refs.validateForm.reset()
            this.getContacts(response.id)
          })
          .finally(() => {
            this.contactLoading = false
          })
      } else {
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'error',
          text: this.$t('message.common.validationIssue')
        })
      }
    },
    saveUpdateAddressHandler () {
      if (this.$refs.addressReference.$refs.validateForm.validate()) {
        this.addressLoading = true
        let model = this.$formatter.cloneVariable(this.addressModel)
        model.customer_id = this.modelObj.customerid
        this.$_saveUpdateHandler('customeraddresses', model)
          .then(response => {
            this.addressDialog = false
            this.addressModel.id = undefined
            this.$refs.addressReference.$refs.validateForm.reset()
            if (model.type === 'delivery') {
              this.getAddresses(response.id)
            } else if (model.type === 'invoice') {
              this.getInvoiceAddresses(response.id)
            }
          })
          .finally(() => {
            this.addressLoading = false
          })
      } else {
        this.$root.$emit('snackbar', {
          snackbar: true,
          color: 'error',
          text: this.$t('message.common.validationIssue')
        })
      }
    },
    // Search from city API
    loadAllCityByPost () {
      if (this.addressModel.postcode) {
        this.isLoading = true
        const key = process.env.VUE_APP_LOOKUP_CITY_KEY.toString()
        // const user = process.env.VUE_APP_LOOKUP_CITY_USER.toString()
        const options = {
          method: 'GET',
          headers: {
            'X-Mybring-API-Key': key,
            'X-MyBring-API-Uid': 'vitali@avalia.no'
          }
        }

        fetch(`${process.env.VUE_APP_LOOKUP_CITY_URL}${this.addressModel.postcode || ''}.json`, options)
          .then(response => response.json())
          .then(response => {
            const { postalCode } = response
            this.cityList = []
            const cityValues = []
            if (postalCode) {
              postalCode.map(x => {
                cityValues.push(x.city)
              })
            }
            this.cityList = cityValues
            if (cityValues && cityValues.length === 1) {
              this.$set(this.addressModel, 'city', cityValues[0])
            } else {
              this.$set(this.addressModel, 'city', '')
            }
            this.isLoading = false
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    createOrderFromOffer () {
      this.offerCreation.loading = true
      this.$_executeApi(
        'post',
        `orders/create_order_from_offer/${this.modelObj.id}`
      )
        .then(response => {
          this.$store.commit('isChangesMade', false)
          this.offerCreation.dialog = false
          this.$router.push(`/${this.MODULE_URL}/edit/${response.data.id}/view`)
          this.$root.$emit('snackbar', {
            snackbar: true,
            color: 'success',
            text: this.$t('message.common.updatedSuccess')
          })
        })
        .finally(() => {
          this.offerCreation.loading = false
        })
    },
    getSettings () {
      this.$_executeApi('get', 'commonsettings').then(response => {
        let settings = response.data
        if (this.module === 'offer') {
          if (!this.modelObj.standardsales) this.modelObj.standardsales = settings.standradoffertext || ''
        } else {
          if (!this.modelObj.standardsales) this.modelObj.standardsales = settings.standradordertext || ''
        }
        if (!this.modelObj.deliveryterms) this.modelObj.deliveryterms = settings.standraddeliveryterms || ''
      })
    },
    downloadOrder (type) {
      if (type === 3) {
        this.$parent.downloadPackListOrder()
      } else if (type === 7) {
        this.$parent.downloadOrderWithZone(7)
      } else if (type === 6) {
        this.$parent.downloadPurchaseListOrder(6)
      } else this.$parent.downloadOrder(type)
    },
    shareOrder (type) {
      this.$parent.getOrderData()
      this.$parent.sendReport(type)
    },
    getCommaStringFromObj (obj) {
      Object.keys(obj).forEach(key => !obj[key] && delete obj[key])
      return Object.values(obj).join(', ')
    },
    verifyVat (vat) {
      if (vat) {
        this.vatLoading = true
        this.$_checkOrganzationExistsInElma(vat)
          .then((organizationExists) => {
            if (organizationExists) {
              this.paymentMethodTwo.push({
                id: 2,
                text: this.$t('message.invoice.saveAndUseEHF')
              })
            } else {
              var removeIndex = this.paymentMethodTwo.findIndex(
                x => x.id === 2
              )
              if (removeIndex && removeIndex !== -1) { this.paymentMethodTwo.splice(removeIndex, 1) }
            }
          })
          .finally(() => {
            this.vatLoading = false
          })
      }
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    },
    supportingList (type, text) {
      const modelName = text
      text = this.$refs.offerReference.$refs[text][0].lazySearch
      let model = { module: type, dialog: true, text, modelName }
      this.$store.commit('supportingList', model)
    },
    updateProbability () {
      if (this.module === CONSTANTS.OFFER) {
        switch (this.modelObj.state) {
          case CONSTANTS.NEW:
            this.modelObj.probability = '20'
            break
          case CONSTANTS.SENT:
            this.modelObj.probability = '30'
            break
          case CONSTANTS.ACCEPTED:
            this.modelObj.probability = '100'
            break
          case CONSTANTS.NOT_ACCEPTED:
            this.modelObj.probability = '0'
            break
        }
      }
      this.changesMade()
    },
    getSalesReference () {
      this.salesNumberLoading = true
      this.$_executeApi('get', 'orders/get_sales_reference')
        .then(response => {
          if (response.data) {
            this.modelObj.salesreference = response.data || ''
          }
        })
        .finally(() => {
          this.salesNumberLoading = false
        })
    },
    showFolderTemplateDialog () {
      this.folderTemplateDialog = true
      this.folderTemplateDialogLoader = true
      this.$_executeApi('get', 'foldertemplates/get_templates').then(({ data }) => {
        this.folderTemplates = data
        if (data && data.length > 0) this.selectedFolderTemplate = data[0].id
      }).finally(() => { this.folderTemplateDialogLoader = false })
    },
    async createFolderTemplate (sharepointId) {
      this.folderTemplateSubmitBtnLoading = true
      var model = { templateid: this.selectedFolderTemplate, folderid: sharepointId }
      await this.$_executeApi('post', 'sharepoint/create_from_template', model)
        .finally(() => {
          this.folderTemplateSubmitBtnLoading = false
          this.folderTemplateDialog = false
          this.selectedFolderTemplate = null
          this.folderTemplates = []
        })
    },
    closeFolderTemplateDialog (isClose = false) {
      this.folderTemplateDialog = false
      this.folderTemplates = []
      if (!isClose) {
        this.saveUpdateHandler(this.SAVE, true)
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('downloadLoading')
    this.$eventBus.$off('showRelatedItems')
    this.$eventBus.$off('loadOffer')
    this.$eventBus.$off('loadHistory')
    this.$eventBus.$off('saveUpdateHandler')
    this.$eventBus.$off('setItemInField')
  }
}
</script>
